import Model from 'offline/stream/model/base'

export default Model.extend({
	table: 'family',
	prefix: 'family',
	key: 'family_id',
	fields: {
		family_id: Model.SCHEMA_NUMBER,
		family_name: Model.SCHEMA_TEXT
	},
	methods: {
		to_array: function() {
			return {
				family_id: this.get_id(),
				family_name: this.rawData().family_name
			}
		}
	}
})
